import React from 'react';
import { SalvLabel } from '@salvapp/ui-components';
import { InternalApiCustomListRecordStatus } from '../../api-internal';

interface Props {
  status?: InternalApiCustomListRecordStatus;
}

export const CustomListRecordStatusLabel = ({ status }: Props) => {
  const isDraft = status === InternalApiCustomListRecordStatus.DRAFT;
  return <SalvLabel variant={isDraft ? 'primary' : 'success'}>{isDraft ? 'Draft' : 'Active'}</SalvLabel>;
};

export default CustomListRecordStatusLabel;
